import { FieldInputs, PlanType, SavedPlanInput } from "../types";

export const fromPlanType = (planType: PlanType) => {
  switch (planType) {
    case PlanType.ORIGINAL:
      return 'Original';
    case PlanType.RETROACTIVE:
      return 'Retroactivo';
    case PlanType.RETROACTIVE:
      return 'Retroactivo';
  }
}


export type ArrVal = {
  value: number
};

export const filterArrVals = (v: ArrVal | number) => {
  const value = (v as ArrVal).value;
  // console.log(`value: ${value}`)
  return !(value != null && value != undefined);
}

export const savedInputsToFieldInputs = (inputs: SavedPlanInput): FieldInputs => {
  return {
    ...inputs,
    investment_scenarios: (inputs.investment_scenarios?.split(',').map(v => parseFloat(v)) as number[]) ?? [],
    mod_40_scenarios: (inputs.mod_40_scenarios?.split(',').map(v => parseFloat(v)) as number[]) ?? [],
  }
};